/* eslint-disable jsx-a11y/mouse-events-have-key-events */
// TODO: Fix accessibility

import { useCallback, useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import { IMAGES_REPO } from '../../../../static-resources';
import MegaMenuCapabilitiesComponent from '../../../megamenucapabilities/megamenucpabilities.component';
import { NavigationButtonComponent } from './buttons/navigation-button.component';
import { AppNavigation } from './interfaces/navigation.interface';
import './navigation-top-bar.component.scss';

const NavigationTopPublicBarComponent = ({
  leftMenuList,
  rightMenuList,
}: {
  leftMenuList: AppNavigation[];
  rightMenuList: AppNavigation[];
}) => {
  const [show, setShow] = useState(false);
  const onMouseOverCallback = useCallback(() => {
    setShow(true);
  }, []);
  const onMouseOutCallback = useCallback(() => {
    setShow(false);
  }, []);
  return (
    <>
      <Navbar.Toggle aria-controls="basic-navbar-nav" />
      <Navbar.Collapse id="basic-navbar-nav ">
        <Nav className="left-nav nav-pills">
          {leftMenuList.map((item: AppNavigation) => {
            if (item.id === 'capabilities') {
              return (
                <Nav.Item
                  key={item.id}
                  onMouseOver={() => onMouseOverCallback()}
                  onClick={() =>
                    show ? onMouseOutCallback() : onMouseOverCallback()
                  }
                >
                  <NavigationButtonComponent
                    path={item.path}
                    id={item.id}
                    icon={item.icon}
                    name={item.name}
                    className={`d-flex align-items-center ${item.className}`}
                  >
                    <img
                      className={
                        show
                          ? 'w-dropdown-button close'
                          : 'w-dropdown-button open'
                      }
                      src={IMAGES_REPO.SimpleArrow}
                      loading="lazy"
                      alt=""
                      height={18}
                      width={18}
                    />
                  </NavigationButtonComponent>

                  <div
                    className={
                      show ? 'w-dropdown-list w--open' : 'w-dropdown-list'
                    }
                    onMouseOut={() => onMouseOutCallback()}
                  >
                    <MegaMenuCapabilitiesComponent />
                  </div>
                </Nav.Item>
              );
            } else {
              return (
                <Nav.Item key={item.id}>
                  <NavigationButtonComponent
                    path={item.path}
                    id={item.id}
                    icon={item.icon}
                    name={item.name}
                    className={item.className}
                  />
                </Nav.Item>
              );
            }
          })}
        </Nav>
        <Nav className="right-nav nav-pills">
          {rightMenuList.map((item: AppNavigation) => (
            <Nav.Item key={item.id}>
              <NavigationButtonComponent
                path={item.path}
                id={item.id}
                icon={item.icon}
                name={item.name}
                className={item.className}
              />
            </Nav.Item>
          ))}
        </Nav>
      </Navbar.Collapse>
    </>
  );
};

export default NavigationTopPublicBarComponent;
